import { useCallback, useEffect } from 'react';
import { useRecoilValue, useSetRecoilState } from 'recoil';
import { getFencesFile, getFencesFileKey } from '../../services/fenceService';
import { apiParamsState } from '../../storage/app';
import { fencesGeojsonState, updatedFencesKeyState } from '../../storage/map';
import useUpdateEffect from '../../hooks/useUpdateEffect';

export function FencesGeoJsonProvider() {
  const apiParams = useRecoilValue(apiParamsState);
  const setFencesGeojson = useSetRecoilState(fencesGeojsonState);
  const updatedFencesKey = useRecoilValue(updatedFencesKeyState);

  const handleFileRead = useCallback(
    (event: any) => {
      const content = JSON.parse(event.target.result);
      setFencesGeojson(content);
    },
    [setFencesGeojson]
  );

  useEffect(() => {
    const invalid = !apiParams?.clientId || !apiParams.subClientId;
    if (invalid) return;

    const loadFencesFile = async () => {
      const { key, error: fileKeyError } = await getFencesFileKey(apiParams.clientId, apiParams.subClientId);
      if (!fileKeyError && key) {
        const { file, error: fileError } = await getFencesFile(key);
        if (!fileError && file) {
          const reader = new FileReader();
          reader.onload = handleFileRead;
          reader.readAsText(file);
        } else {
          setFencesGeojson(undefined);
        }
      } else {
        setFencesGeojson(undefined);
      }
    };
    loadFencesFile();
  }, [apiParams?.clientId, apiParams?.subClientId, setFencesGeojson, handleFileRead]);

  useUpdateEffect(() => {
    if (!updatedFencesKey) return;

    const updateFencesFile = async () => {
      const { file, error: fileError } = await getFencesFile(updatedFencesKey);
      if (!fileError && file) {
        const reader = new FileReader();
        reader.onload = handleFileRead;
        reader.readAsText(file);
      } else {
        setFencesGeojson(undefined);
      }
    };
    updateFencesFile();
  }, [updatedFencesKey]);

  return null;
}
